<template>
    <v-col v-bind="DASHBOARD_WIDGET_COLUMNS.SMALL">
        <v-alert type="info" variant="tonal">
            <div class="text-body-1">{{ displayTitle }}</div>
            <div class="text-body-2 mt-1">{{ t('common.dashboard.labels.noData') }}</div>
        </v-alert>
    </v-col>
</template>

<script setup lang="ts">
/*
Organization / ordering applied:
1. Imports
2. Props / Emits
3. Constants
4. Stores & top-level services
5. Reactive state (refs/reactive)
6. Validation rules & setup
7. Computed
8. Handlers / methods
9. Helpers / lifecycle
*/

// 1. Imports
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import type { DashboardWidget } from '@/stores/dashboard'
import { DASHBOARD_WIDGET_COLUMNS, getDashboardWidgetDisplayTitle } from '@/views/Dashboard/dashboardUtils'

// 2. Props / Emits
const props = defineProps<{
    widget: DashboardWidget
}>()

// 4. Stores & top-level services
const { t } = useI18n()

// 7. Computed
const displayTitle = computed(() => getDashboardWidgetDisplayTitle(props.widget))
</script>
